// extracted by mini-css-extract-plugin
export default {"button":"MassiveActionsDropdown_button__SglJt","group":"MassiveActionsDropdown_group__m-1jk","container":"MassiveActionsDropdown_container__6zRbS"};